export function sanitizeTextForMol(text) {
    return text.replace(/[\u2013\u2014\u2212]/g, '-')
        .replace(/[\u202F]/g, ' ')
        .replace(/&nbsp;/img, ' ');
}
